/**
 * Provides authenticated LawbaseAPI requests for managed network locations.
 * Authentication and the API base URL remain centralized in axiosConfig.
 */
import axios from "../http-config/axiosConfig";

/**
 * Returns the successful result from the shared response envelope.
 *
 * @param {object} data LawbaseAPI response data.
 * @returns {*} The response result.
 * @throws {Error} When the API reports a business failure.
 */
const unwrapResponse = (data) => {
	if (!data?.isSuccess) {
		throw new Error(data?.message || "The network-location request failed.");
	}

	return data.result;
};

const networkLocationsApi = {
	/**
	 * Loads managed network locations.
	 *
	 * @param {{includeInactive?: boolean}} options Read options.
	 * @returns {Promise<Array>} The requested locations.
	 */
	getNetworkLocationsAsync: async ({ includeInactive = false } = {}) => {
		const { data } = await axios.get("/NetworkLocations", {
			params: { includeInactive },
		});
		return unwrapResponse(data);
	},

	/**
	 * Replaces the complete managed network-location state.
	 *
	 * @param {Array} locations Complete normalized list.
	 * @returns {Promise<Array>} The stored normalized list.
	 */
	updateNetworkLocationsAsync: async (locations) => {
		const { data } = await axios.put("/NetworkLocations", locations);
		return unwrapResponse(data);
	},
};

export default networkLocationsApi;
